export function nuevaSubasta() {
    window.location.href = '/subastas/edicion';
}
  
// Redirige a la página de visualización de una subasta específica
export function verSubasta(id) {
  window.location.href = `/subastas/vista?id=${id}`;
}

// Redirige a la página de edición de una subasta específica
export function editarSubasta(id) {
  window.location.href = `/subastas/edicion?id=${id}`;
}

// Redirige a la página de listado de lotes
export function verLotesSubasta(subastaId) {
  window.location.href = `/subastas/lotes?subastaId=${subastaId}`;
}

// Redirige a la página de listado de lotes
export function verLote(loteId) {
  window.location.href = `/lotes?id=${loteId}`;
}

export function verCategoriaLote(tipificado_id) {
  window.location.href = `/lotes/categorias/${tipificado_id}`;
}


// redirigir a la portada de subasta
export function redirigirSubastaPortada(id) {
  window.location.href = `/subastas/lotes?subastaId=${id}`;
}


export function redirigirCertificaciones() {
  window.open(`${process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL}/certificaciones`, '_self');
}

// Redirige al login del sitio web
export function redirigirALogin() {
  window.open('/login', '_self');
}